import axios from 'axios';
import { userRoles } from 'src/reducers/sessionReducer';
import adminNavConfig from 'src/layouts/Dashboard/navConfig';

const instance = axios.create();
export const superAxios = axios.create();

/**
 * Fix a hardcodear rutas de ADMIN siendo SUPERADMIN
 */
const adminPaths = adminNavConfig.map(navConf =>
  navConf.items
    .filter(item => item.href !== '/auth/logout')
    .map(item => item.href)
);
const mergedAdminPaths = Array.prototype.concat.apply([], adminPaths);

export const setupAxios = (store, history) => {
  instance.interceptors.request.use(
    config => {
      const session = store.getState().session;
      const userType = session?.userType;
      let authorization = '';

      let inAdminPath = false;
      mergedAdminPaths.forEach(path => {
        if (path === window.location.pathname) {
          inAdminPath = true;
        }
      });
      if (userType === userRoles.SUPERADMIN && inAdminPath) {
        history.push('/super/companies');
        return Promise.resolve(true); // promise que no hace nada, sigue arrojando "error"
      } else if (userType === userRoles.ADMIN) {
        authorization = session.persistor.admin.token;
      } else if (userType === userRoles.PLAY_AS) {
        authorization = session.persistor.playAs.token;
      }
      config.headers.authorization = authorization;
      return config;
    },
    error => Promise.reject(error)
  );

  instance.interceptors.response.use(
    response => response,
    async error => {
      if (error.response?.status === 401) {
        const session = store.getState().session;
        const userType = session?.userType;
        if (
          userType === userRoles.SUPERADMIN ||
          userType === userRoles.PLAY_AS
        ) {
          history.push('/auth/super/login');
        } else {
          history.push('/auth/login');
        }
        window.localStorage.clear();
      }
      return Promise.reject(error);
    }
  );

  superAxios.interceptors.request.use(
    config => {
      const session = store.getState().session;
      let authorization = '';
      if (
        session.userType === userRoles.SUPERADMIN ||
        session.userType === userRoles.PLAY_AS
      ) {
        authorization = session.persistor.superAdmin.token;
      }
      config.headers.authorization = authorization;
      return config;
    },
    error => Promise.reject(error)
  );

  superAxios.interceptors.response.use(
    response => response,
    error => {
      if (error.response?.status === 401) {
        history.push('/auth/super/login');
        window.localStorage.clear();
      }
      return Promise.reject(error);
    }
  );
};

export default instance;
